import { render } from "./MessengerForm.vue?vue&type=template&id=7822b9e6"
import script from "./MessengerForm.vue?vue&type=script&lang=js"
export * from "./MessengerForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__